import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { LogoMark } from '../components/Logo';
import { isPlatformAdminUser } from '../lib/platformAdmin';

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const updateScrolled = () => setScrolled(window.scrollY > 2);
    updateScrolled();
    window.addEventListener('scroll', updateScrolled, { passive: true });
    return () => window.removeEventListener('scroll', updateScrolled);
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setErr(null); setLoading(true);
    try {
      const user = await login(email, password);
      nav(isPlatformAdminUser(user) ? '/internal' : '/dashboard');
    } catch (e) {
      setErr(e?.response?.data?.error || 'Login failed');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col pt-16">
      <header className={`fixed inset-x-0 top-0 z-50 border-b idemgo-home-header ${scrolled ? 'idemgo-home-header-scrolled' : ''}`}>
        <div className="max-w-[1200px] mx-auto px-6 h-16 flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2"><LogoMark size={25}/><span className="font-display text-lg font-bold">idemGO</span></Link>
          <Link to="/signup" data-testid="login-go-signup" className="text-sm text-zinc-600 hover:text-black">Create free account</Link>
        </div>
      </header>
      <main className="flex-1 grid place-items-center px-6 py-16 idemgo-grid-bg">
        <form onSubmit={submit} data-testid="login-form" className="w-full max-w-sm border border-zinc-200 bg-white p-8 rounded-sm">
          <p className="text-xs font-mono uppercase tracking-widest text-zinc-500">Sign in</p>
          <h1 className="font-display text-2xl font-bold mt-1">Welcome back</h1>
          <p className="text-sm text-zinc-500 mt-1">Access your KYC verification dashboard.</p>

          <label className="block text-xs uppercase tracking-widest text-zinc-500 mt-6 mb-1">Email</label>
          <input data-testid="login-email" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)}
            className="w-full border border-zinc-200 rounded-sm px-3 py-2 text-sm focus:outline-none focus:border-black"/>

          <label className="block text-xs uppercase tracking-widest text-zinc-500 mt-4 mb-1">Password</label>
          <input data-testid="login-password" type="password" required value={password} onChange={(e)=>setPassword(e.target.value)}
            className="w-full border border-zinc-200 rounded-sm px-3 py-2 text-sm focus:outline-none focus:border-black"/>

          {err && <p data-testid="login-error" className="text-sm text-red-700 mt-3">{err}</p>}

          <button data-testid="login-submit" disabled={loading}
            className="w-full mt-6 bg-black text-white rounded-sm py-2.5 text-sm font-medium hover:bg-zinc-800 disabled:opacity-50">
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </main>
    </div>
  );
}
